function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from "react";
import ReactLoader from "../../../../__snowpack__/pkg/react-loader-spinner.js";
import "../../../../__snowpack__/pkg/react-loader-spinner/dist/loader/css/react-spinner-loader.css.proxy.js";
import {cmpClassName, parseSize} from "../../../common/generic-react.functions.js";
import {LoaderContainer} from "./loader.styles.js";
function Loader({
  color = "black",
  size = "base",
  type = "Oval",
  ...otherProperties
}) {
  const svgSize = parseInt(parseSize(size, true), 10);
  return /* @__PURE__ */ React.createElement(LoaderContainer, _extends({
    className: cmpClassName("loader"),
    role: "loader"
  }, otherProperties, {
    color
  }), /* @__PURE__ */ React.createElement(ReactLoader, {
    type,
    color,
    height: svgSize,
    width: svgSize
  }));
}
export default Loader;
